import { Box, Flex, chakra, useColorModeValue } from '@chakra-ui/react';
import clamp from 'lodash/clamp';
import React from 'react';

import Skeleton from 'ui/shared/chakra/Skeleton';
interface Props {
  className?: string;
  value: number;
  colorScheme?: 'green' | 'gray';
  isLoading?: boolean;
}

const WIDTH = 50;

const Utilization = ({ className, value, colorScheme = 'green', isLoading }: Props) => {
  const valueString = (clamp(value * 100 || 0, 0, 100)).toLocaleString(undefined, { maximumFractionDigits: 2 }) + '%';
  const colorGrayScheme = useColorModeValue('gray.500', '#999999');
  const color = colorScheme === 'gray' ? colorGrayScheme : 'green.500';
  const textColor = useColorModeValue('#999999', '#999999');

  return (
    <Flex className={ className } alignItems="center" columnGap={ 2 }>
      <Skeleton isLoaded={ !isLoading } color={ textColor } fontWeight="medium" fontFamily="'Oxanium', sans-serif" fontSize="14px" lineHeight="18px">
        <span>
          ({ valueString })
        </span>
      </Skeleton>
      <Skeleton isLoaded={ !isLoading } w={ `${ WIDTH }px` } h="4px" borderRadius="full" overflow="hidden" mr={ 2 }>
        <Box bg={ useColorModeValue('blackAlpha.200', 'whiteAlpha.200') } h="100%">
          <Box bg={ color } w={ valueString } h="100%"/>
        </Box>
      </Skeleton>
    </Flex>
  );
};

export default React.memo(chakra(Utilization));
